import { render, staticRenderFns } from "./IlliquidReportView.vue?vue&type=template&id=427c66ba&scoped=true&"
import script from "./IlliquidReportView.vue?vue&type=script&lang=js&"
export * from "./IlliquidReportView.vue?vue&type=script&lang=js&"
import style0 from "./IlliquidReportView.vue?vue&type=style&index=0&id=427c66ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427c66ba",
  null
  
)

export default component.exports